import React from 'react';

export const AnnouncementBar = () => {
  return (
    <div 
      className="w-full bg-[hsl(var(--secondary))] text-[hsl(var(--secondary-foreground))] border-b border-black/5 py-2 px-4 text-center"
      data-testid="announcement-bar"
    >
      <p className="text-sm font-medium">
        🚚 <span data-testid="announcement-free-delivery">Free Delivery on All Orders</span> • 
        <span data-testid="announcement-dispatch-note" className="hidden sm:inline">Same Day Dispatch</span>
      </p>
    </div>
  );
};

export const FreeDeliveryPill = ({ className = "" }) => {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border border-[hsl(32_95%_44%)] bg-[hsl(43_96%_92%)] text-[hsl(222_47%_11%)] ${className}`}
      data-testid="free-delivery-pill"
    >
      🚚 FREE DELIVERY
    </span>
  );
};